module.exports = __webpack_public_path__ + "img/cart.12173be9.png";